import * as type from './type';
import util from 'common/js/util';

export default{
    //获取推荐品牌商列表
    [type.GET_BRAND_LIST](context, option){
        util.post({
            params: {
                functionId: 'getSuppliers',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //申请合作
    [type.APPLY_CORP](context, option){
        util.post({
            params: {
                functionId: 'applySuppliersCorp',
                body: JSON.stringify(option.params)
            },
            sc(data){
                if(option && option.sc){
                    option.sc && option.sc(data);
                }
            },
            fc(data){
                if(option && option.fc){
                    option.fc && option.fc(data);
                }
            }
        });
    },
}



// WEBPACK FOOTER //
// ./src/store/brand/actions.js